import type { IKpiRepository } from '../repositories/IKpiRepository.js';
import type { KpiValueEntity } from '../entities/KpiEntity.js';

interface Deps { kpiRepository: IKpiRepository; }
export function createListKpiValuesUseCase({ kpiRepository }: Deps) {
  return async function listKpiValues(kpiId: string): Promise<KpiValueEntity[]> {
    return kpiRepository.listValues(kpiId);
  };
}
